"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const useChangeReviewer_1 = require("hooks/api/useChangeReviewer");
const useIntersectionObserver_1 = __importDefault(require("hooks/useIntersectionObserver"));
const HelperUtils_1 = require("utils/HelperUtils");
const ProfileType_1 = __importDefault(require("components/design-system/ProfileType"));
const Table_1 = __importDefault(require("components/design-system/table/Table"));
const ListEmptyState_1 = __importDefault(require("components/shared/ListEmptyState"));
const RevieweeNotFoundContent = () => {
    const [sort, setSort] = (0, react_1.useState)({
        sortColumn: 'name',
        sortDirection: 'asc'
    });
    const { id } = (0, react_router_1.useParams)();
    const intersectTarget = (0, react_1.createRef)();
    const headers = [
        {
            name: 'reviewee',
            widthClass: 'w-[200px]',
            grow: true,
            sort: {
                sortColumn: sort?.sortColumn,
                sortDirection: sort?.sortDirection,
                onSort: (direction) => setSort({ sortColumn: sort?.sortColumn, sortDirection: direction })
            }
        },
        { name: 'nip', widthClass: 'w-[430px]' },
        { name: 'reason', widthClass: 'w-[430px]' }
    ];
    const params = {
        sortColumn: sort.sortColumn,
        sortDirection: sort.sortDirection,
        type: 'user_not_found',
        limit: 10
    };
    const { data: rData, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage, isFetching } = (0, useChangeReviewer_1.useChangeReviewer)(id, params);
    (0, useIntersectionObserver_1.default)({
        target: intersectTarget,
        threshold: 0.5,
        onIntersect: (entry) => {
            if (!entry.isIntersecting)
                return;
            if (!hasNextPage)
                return;
            if (isFetching)
                return;
            fetchNextPage();
        }
    });
    return (react_1.default.createElement(Table_1.default, { headers: headers },
        isLoading &&
            [...new Array(10)].map((_, index) => {
                return react_1.default.createElement(Table_1.default.LoadingRow, { key: index });
            }),
        !isLoading && rData?.length == 0 && (react_1.default.createElement(ListEmptyState_1.default, { fullHeight: true, size: "large", emptyIcon: "icon-no-user", title: (0, HelperUtils_1.getObjectiveLocale)('No user found') })),
        rData &&
            rData.map((dt, index) => {
                return (react_1.default.createElement(Table_1.default.Row, { key: index, useRowHover: false },
                    react_1.default.createElement(Table_1.default.Column, { customClass: "w-[200px]", grow: true },
                        react_1.default.createElement(ProfileType_1.default, { customClass: "min-w-[0px] items-center", tooltipClassContainer: "min-w-[0px]", user: dt.target, title: dt.target.name, subtitle: dt.target.jobTitle, titleClassName: "typography-h400", subtitleClassName: "typography-h100 typography-secondary" })),
                    react_1.default.createElement(Table_1.default.Column, { widthClass: "w-[430px]" },
                        react_1.default.createElement("span", { className: "typography-paragraph text-n-900" }, dt.target.externalId)),
                    react_1.default.createElement(Table_1.default.Column, { widthClass: "w-[430px]", customClass: "typography-paragraph text-n-900" }, dt.message)));
            }),
        isFetchingNextPage && react_1.default.createElement(Table_1.default.LoadingRow, null),
        react_1.default.createElement("div", { ref: intersectTarget })));
};
exports.default = RevieweeNotFoundContent;
